var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-layout"},[_c('div',{staticClass:"sidebar"},[_c('AdminSidebar')],1),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"header"},[_c('AdminHeader')],1),_c('div',{staticClass:"content"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }